import React, {useState, useEffect} from 'react';
import {Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Spinner} from "reactstrap";
import {updateDoc, collection, doc, getDoc} from "firebase/firestore";
import {getDb} from "../../util/Constants";

function EditDifficulty(props) {
    const [rewardName, setRewardName] = useState("");
    const [rewardValue, setRewardValue] = useState("");
    const [load, setLoad] = useState(false);


    useEffect(() => {
        fetchData()
    }, [props.modal])
    const fetchData = async () =>{
            setRewardName(props?.item?.rewardName);
            setRewardValue(props?.item?.rewardValue);
    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        setLoad(true);
        const docRef = doc(getDb(), "util", "meta");
        // let dataCapital = difficulty.charAt(0).toUpperCase() + difficulty.slice(1)
        await updateDoc(docRef, {
         optionRewards:{
             ...props.Obj,[rewardName]:Number(rewardValue)
         }
        });
        props.getOptions();
        setLoad(false);
        props.toggle();

    };


    return (
        <div>
            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Edit Question Reward</ModalHeader>
                <ModalBody style={{paddingTop: "10px"}}>
                    <Form onSubmit={handleSubmit}>
                        <div className="">

                            <FormGroup>
                                <Label for="department">
                                    Question Type
                                </Label>
                                <Input
                                    type="text"
                                    id="department"
                                    maxLength="250"
                                    value={rewardName}
                                    disabled
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setRewardName(e.target.value)}
                                />

                            </FormGroup>
                            <FormGroup>
                                <Label for="department">
                                    Type Score
                                </Label>
                                <Input
                                    type="number"
                                    value={rewardValue}
                                    min={0}
                                    max={9999}
                                    required
                                    className="form-control-alternative"
                                    onChange={(e) => setRewardValue(e.target.value)}
                                />

                            </FormGroup>
                        </div>
                        <Button color="primary" type={"submit"} disabled={load}>
                            {load ? (
                                <Spinner color="light" size="sm"/>
                            ) : (
                                "Save"
                            )}
                        </Button>
                        <Button color="secondary" onClick={props.toggle}>
                            Cancel
                        </Button>
                    </Form>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default EditDifficulty;